"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
const paymentMethods = [{
  id: "visa",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/trust_badge_expert.png",
  alt: "Expert Tested"
}, {
  id: "mastercard",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/trust_badge_trusted.png",
  alt: "Trusted Reviews"
}, {
  id: "jcb",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/trust_badge_updated.png",
  alt: "Updated Monthly"
}, {
  id: "amex",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/partner_amazon.png",
  alt: "Amazon Associate"
}, {
  id: "paypal",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/partner_impact.png",
  alt: "Impact Partner"
}, {
  id: "shopeepay",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687986/img/partner_shareasale.png",
  alt: "ShareASale"
}];
const socialLinks = [{
  id: "facebook",
  icon: Twitter,
  label: "Twitter",
  href: "#"
}, {
  id: "instagram",
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  id: "twitter",
  icon: Twitter,
  label: "YouTube",
  href: "#"
}, {
  id: "linkedin",
  icon: Linkedin,
  label: "LinkedIn",
  href: "#"
}];
const countries = ["United States", "Canada", "United Kingdom", "Australia", "Germany", "France", "Spain", "Italy", "Netherlands", "Sweden", "Norway"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {[1, 2].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
            <div className="flex flex-col gap-2">
              {[1, 2, 3, 4, 5].map((_, j) => <div key={j} data-index={j} className="h-3 w-32 bg-muted/50 animate-pulse rounded-md" />)}
            </div>
          </div>)}
      </div>;
  }
  const columns = menuItems.filter(item => item.children && item.children.length > 0);
  if (columns.length > 0) {
    return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {columns.slice(0, 2).map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
            
            <ul className="flex flex-col gap-2.5">
              {col.children?.map((child, j) => <li key={child.id} data-index={j}>
                  <Link to={child.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs font-default">
                    {child.label}
                  </Link>
                </li>)}
            </ul>
          </div>)}
      </div>;
  }
  const mid = Math.ceil(menuItems.length / 2);
  const col1 = menuItems.slice(0, mid);
  const col2 = menuItems.slice(mid);
  return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
      <div className="flex flex-col gap-4">
        <h3 className="font-default font-bold text-foreground uppercase tracking-widest text-xs">
          Expert Reviews
        </h3>
        <ul className="flex flex-col gap-2.5">
          {col1.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs font-default">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="font-default font-bold text-foreground uppercase tracking-widest text-xs">
          Buying Guides
        </h3>
        <ul className="flex flex-col gap-2.5">
          {col2.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs font-default">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </div>;
}
export default function Footer() {
  return <footer data-section-id="264741" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12 mb-12">
          
          {}
          <MenuProvider menu_id="footer_menu">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-bold text-foreground uppercase tracking-widest text-xs"><br /></h3>
            
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-bold text-foreground uppercase tracking-widest text-xs">
              Follow SafeBode
            </h3>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <li key={social.id} data-index={i}>
                    <Link to={social.href} className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-xs group font-default">
                      <Icon className="size-4 group-hover:scale-110 transition-transform" />
                      <span>{social.label}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-bold text-foreground uppercase tracking-widest text-xs">
              SafeBode Mission
            </h3>
            <div className="flex flex-col gap-3 items-start">
              <p className="text-[11px] leading-relaxed text-muted-foreground font-default">
                SafeBode provides independent, research-driven reviews of home security and safety products to help families make smarter decisions for a safer home.
              </p>
              <div className="flex flex-col gap-2 w-full">
                
                
              </div>
            </div>
          </div>

        </div>

        <Separator className="mb-8 bg-border/30" />

        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 text-[11px] text-muted-foreground font-default">
          <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
            <Link to="/HomePage" className="shrink-0">
              <WvcLogo className="h-8 w-auto opacity-90 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" />
            </Link>
            <p className="max-w-md">© {new Date().getFullYear()} SafeBode. Affiliate Disclosure: We may earn a commission when you buy through links on our site. This helps support our independent testing.</p>
          </div>
          
          
        </div>
      </div>
    </footer>;
}